/**
 * Packeta widget loader — DISABLED.
 *
 * Pickup points are entered by hand (components/address/pickup-point-form.vue), so the
 * widget script is not loaded and no request goes to widget.packeta.com. The plugin file
 * is kept as a no-op so re-enabling is a matter of restoring the body below.
 *
 * See packeta.md in the repository root for the full re-integration checklist.
 */
export default defineNuxtPlugin(() => {
  return null;

  // const config = useRuntimeConfig();
  //
  // return new Promise((resolve) => {
  //   if (typeof window !== 'undefined' && window.Packeta) {
  //     resolve(window.Packeta);
  //     return;
  //   }
  //
  //   if (!config.public.packetaApiKey) {
  //     resolve(null);
  //     return;
  //   }
  //
  //   const preconnectLink = document.createElement('link');
  //   preconnectLink.rel = 'preconnect';
  //   preconnectLink.href = 'https://widget.packeta.com';
  //   document.head.appendChild(preconnectLink);
  //
  //   const script = document.createElement('script');
  //   script.src = 'https://widget.packeta.com/v6/www/js/library.js';
  //   script.async = true;
  //   script.onload = () => resolve(window.Packeta);
  //   script.onerror = () => resolve(null);
  //   document.head.appendChild(script);
  // });
});
